import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetLeadTimeForChangesRange from "shared/DoraMetrics/useGetLeadTimeForChangesRange";

import useDoraDateRange from "../useDateRange";

const useDoraLeadTimeChangesRange = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { range, hasRuns, loading, error, refetch, networkStatus } = useGetLeadTimeForChangesRange({
    startTimeUnix: getUnixTime(startTime),
    endTimeUnix: getUnixTime(endTime),
  });

  const isLoading = (loading && !range) || networkStatus === NetworkStatus.refetch;

  return {
    range,
    hasRuns,
    isLoading,
    error,
    refetch,
  };
};

export default useDoraLeadTimeChangesRange;
